import { useAuth } from "@/features/Auth/lib/useAuth";
import { useFormattedPlans } from "./useFormattedPlans";
import { useMemo } from "react";
import { usePlan } from "@/entities/Plan";
import { usePlanSwitcher } from "../../_common/planSwitcher/usePlanSwitcher";
import { isSalesSystemAccount } from '@/features/Auth/lib/salesAccess';

const useActionPopup = () => {
  const formattedPlans = useFormattedPlans();
  const { myPlans } = usePlan();
  const { user } = useAuth();
  const showAllPlans = isSalesSystemAccount(user);

  const ownPlans = useMemo(
    () =>
      showAllPlans ? [] : myPlans?.filter(
        (plan) =>
          plan.user_id === user?.bx.bx_user.bx_id && plan.created_by !== user?.bx.bx_user.bx_id
      ) || [],
    [myPlans, user, showAllPlans]
  );

  const assignedPlans = useMemo(
    () =>
      showAllPlans ? (myPlans ?? []) : myPlans?.filter(
        (plan) =>
          plan.created_by === user?.bx.bx_user.bx_id && plan.user_id !== user?.bx.bx_user.bx_id
      ) || [],
    [myPlans, user, showAllPlans]
  );

  const showOwnPlans = ownPlans.length > 0;
  const showAssignedPlans = assignedPlans.length > 0;

  const initialValue = showAllPlans
    ? "assigned"
    : showOwnPlans
    ? "own"
    : showAssignedPlans
    ? "assigned"
    : "own";

  const { value, setValue } = usePlanSwitcher({
    showOwnPlans,
    showAssignedPlans,
    initialValue,
  });

  const filteredPlans = useMemo(() => {
    if (value === "own") {
      return formattedPlans.filter((_, idx) => ownPlans.includes(myPlans?.[idx]!));
    }
    if (value === "assigned") {
      return formattedPlans.filter((_, idx) => assignedPlans.includes(myPlans?.[idx]!));
    }
    return [];
  }, [value, formattedPlans, ownPlans, assignedPlans, myPlans]);

  return {
    showAssignedPlans,
    filteredPlans,
    showOwnPlans,
    showAllPlans,
    value,
    setValue,
  };
};

export default useActionPopup;
